import React from "react";
import {
  ThemeButtonBGPrimary,
  ThemeColor,
  ALERT_TIMEOUT,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  AUTHENTICATION_URL,
} from "../Config";
import { Link } from "react-router";
import { useState, useEffect, useContext } from "react";
import { isValidEmail } from "../Utils";
import { useNavigate } from "react-router";
import { LoggedInContext } from "../../App";
import { GoogleLogin } from "@react-oauth/google";
import LoadingBar from "react-top-loading-bar";

function LoginContent() {
  //navigate
  const navigate = useNavigate(); //react router navigate

  //get ai detector values
  // eslint-disable-next-line no-unused-vars
  const { setIsLoggedIn, setCheckIfLoggedin } = useContext(LoggedInContext);

  //submit form button clicked state
  const [submitClicked, setSubmitClicked] = useState(false);

  //loading progress
  const [progress, setProgress] = useState(0);

  // Function to simulate progress updates
  const startLoading = () => {
    setProgress(30); // Start with some progress
    // Simulate an async operation
    setTimeout(() => {
      setProgress(70);
    }, 500);
  };

  //login values
  const [loginFieldValues, setLoginFieldValues] = useState({
    email_address_login: "",
    password_login: "",
  });

  //alert state
  const [alert, setAlert] = useState({
    type: "success",
    message: "",
    visible: false,
  });

  //use effect handle submit action
  //use effect to handle the submit button click
  useEffect(() => {
    // If the submit button was clicked
    if (submitClicked === true) {
      //call endpoint
      loginFormRequest();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitClicked]);

  //login from endpoint
  const loginFormRequest = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(AUTHENTICATION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "LOGIN",
        email_address_login: loginFieldValues.email_address_login,
        password_login: loginFieldValues.password_login,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //scroll to top
        window.scrollTo(0, 0);
        //check success
        if (data.success === true) {
          //set previous access token to saved token
          //retreive it when user is not logged in
          //to get old user account id
          localStorage.setItem(
            "access_token_saved",
            localStorage.getItem("access_token")
          );
          //set token
          //if already email verified
          localStorage.setItem("access_token", data.token);
          //reload account details
          //is logged in
          //to get max character length
          setCheckIfLoggedin(true);

          //check if mail verified
          if (data.mail_verified === 1) {
            //set alert state to show error
            setAlert({
              type: "success",
              message: data.message,
              visible: true,
            });
            //hide alert after 5 seconds
            setTimeout(() => {
              setAlert({ ...alert, visible: false });
              //navigate
              //go to main page
              navigate("/"); //Navigate to main page
            }, ALERT_TIMEOUT);

            //reset output
            setLoginFieldValues({
              ...loginFieldValues,
              email_address_login: "",
              password_login: "",
            });
          } else {
            //Navigate to verify email page
            navigate("/verify_email", {
              state: {
                email_address_login: loginFieldValues.email_address_login,
              },
            }); //Navigate to verify email page
          }
        } else {
          //set alert state to show error
          setAlert({
            type: "danger",
            message: data.message,
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        }
        //hide the spinner
        setSubmitClicked(false);
        console.log("Response Data:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //set alert state to show error
        setAlert({
          type: "danger",
          message: "Sorry. Something went wrong. Please try again later.",
          visible: true,
        });
        //hide alert after 5 seconds
        setTimeout(() => {
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);
        //hide the spinner
        setSubmitClicked(false);
      });
  };

  //login request using google credentials endpoint
  const loginUsingGoogleCredentialsRequest = async (token) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(AUTHENTICATION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "LOGIN_USING_GOOGLE_ACCOUNT",
        credential: token,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //scroll to top
        window.scrollTo(0, 0);

        // Simulate an async operation
        setTimeout(() => {
          //set progress
          setProgress(100);
        }, 500);

        //check success
        if (data.success === true) {
          //set previous access token to saved token
          //retreive it when user is not logged in
          //to get old user account id
          localStorage.setItem(
            "access_token_saved",
            localStorage.getItem("access_token")
          );
          //set token
          //if already email verified
          localStorage.setItem("access_token", data.token);
          //reload account details
          //is logged in
          //to get max character length
          setCheckIfLoggedin(true);

          //check if mail verified
          if (data.mail_verified === 1) {
            //set alert state to show error
            setAlert({
              type: "success",
              message: data.message,
              visible: true,
            });
            //hide alert after 5 seconds
            setTimeout(() => {
              setAlert({ ...alert, visible: false });
              //navigate
              //go to main page
              navigate("/"); //Navigate to main page
            }, ALERT_TIMEOUT);
          } else {
            //Navigate to verify email page
            navigate("/verify_email", {
              state: {
                email_address_login: loginFieldValues.email_address_login,
              },
            }); //Navigate to verify email page
          }
        } else {
          //set alert state to show error
          setAlert({
            type: "danger",
            message: data.message,
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        }
        console.log("Response Data:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //set alert state to show error
        setAlert({
          type: "danger",
          message: "Sorry. Something went wrong. Please try again later.",
          visible: true,
        });
        //hide alert after 5 seconds
        setTimeout(() => {
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);

        // Simulate an async operation
        setTimeout(() => {
          //set progress
          setProgress(100);
        }, 500);
      });
  };

  //onvalue change handler for the inputs
  const onChangeLoginForm = (event) => {
    // Update the state with the new value
    setLoginFieldValues({
      ...loginFieldValues,
      [event.target.id]: event.target.value,
    });
  };

  //submit handler for the form
  const onSubmitLoginForm = (event) => {
    // Get the textarea value
    event.preventDefault();

    //check if mail id valid
    //if not valid return and show error
    if (isValidEmail(loginFieldValues.email_address_login) === false) {
      //show error
      //set alert state to show error
      setAlert({
        type: "danger",
        message: `Entered email address ${loginFieldValues.email_address_login} is not valid. Please enter a valid email addess.`,
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);

      //return
      return;
    }

    //check password character count
    if (
      loginFieldValues.password_login.length < PASSWORD_MIN_LENGTH ||
      loginFieldValues.password_login.length > PASSWORD_MAX_LENGTH
    ) {
      //show error
      //set alert state to show error
      setAlert({
        type: "danger",
        message: `Password length must be of ${PASSWORD_MIN_LENGTH}-${PASSWORD_MAX_LENGTH} characters`,
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);

      //return
      return;
    }

    //set the submit clicked state to true
    //can not access the form values directly here
    //as the state is not updated immediately
    //use effect will be called after the state is updated
    setSubmitClicked(true);
  };

  return (
    <div>
      {" "}
      <LoadingBar
        progress={progress}
        onLoaderFinished={() => setProgress(0)} // Reset on completion
      />
      <div className="p-3">
        <div
          className="container col-md-4 col-md-offset-4"
          style={{ marginTop: "6rem" }}
        >
          {/* Alert for failure */}
          <div
            className={`alert alert-${alert.type} ${
              alert.visible ? "" : "d-none"
            } fade show`}
            role="alert"
            style={{ marginTop: "5rem" }}
          >
            {alert.message}
          </div>

          {/*Login screen */}
          <div className="">
            {/* title */}
            <h1 className="display-6 text-center mt-2">Login</h1>

            {/* Sign in with google button */}
            <div
              className="mt-3 text-center justify-content-end d-flex"
              style={{ width: "100%", height: "50px" }}
            >
              <GoogleLogin
                onSuccess={(response) => {
                  console.log(response);
                  //check
                  if (response.credential === null) {
                    //set alert state to show error
                    setAlert({
                      type: "danger",
                      message: "Failed logging in. Try again.",
                      visible: true,
                    });
                    //hide alert after 5 seconds
                    setTimeout(() => {
                      setAlert({ ...alert, visible: false });
                    }, ALERT_TIMEOUT);
                  } else {
                    //process login request
                    loginUsingGoogleCredentialsRequest(response.credential);
                    //start loading bar
                    startLoading();
                  }
                }}
                onError={() => {
                  console.log("Login failed");
                  //set alert state to show error
                  setAlert({
                    type: "danger",
                    message: "Login failed. Please try again later.",
                    visible: true,
                  });
                  //hide alert after 5 seconds
                  setTimeout(() => {
                    setAlert({ ...alert, visible: false });
                  }, ALERT_TIMEOUT);
                }}
              />
            </div>

            {/* Form */}
            <div className="justify-content-center" style={{ width: "100%" }}>
              <form className="mt-3" onSubmit={onSubmitLoginForm}>
                <div className="form-group">
                  <label
                    className="text-muted me"
                    htmlFor="email_address_login"
                  >
                    Email Address
                  </label>
                  <div className="mt-1">
                    <input
                      type="email"
                      className="form-control"
                      id="email_address_login"
                      aria-describedby="emailHelp"
                      placeholder="Email Address"
                      style={{ borderColor: ThemeColor, height: "50px" }}
                      onChange={onChangeLoginForm}
                      value={loginFieldValues.email_address_login}
                    />
                  </div>
                </div>
                <div className="form-group mt-3">
                  <label className="text-muted" htmlFor="password_login">
                    Password ({PASSWORD_MIN_LENGTH} - {PASSWORD_MAX_LENGTH}{" "}
                    characters)
                  </label>
                  <div className="mt-1">
                    <input
                      type="password"
                      className="form-control"
                      id="password_login"
                      placeholder="Password"
                      style={{ borderColor: ThemeColor, height: "50px" }}
                      onChange={onChangeLoginForm}
                      value={loginFieldValues.password_login}
                    />
                  </div>
                </div>
                <div className="mt-2">
                  <Link className="text-muted text-end" to="/forgotpassword">
                    Forgot Password?
                  </Link>
                </div>

                {/* button to Login */}
                <div className="text-center justify-content-center mt-5 d-flex">
                  <div
                    className={`spinner-border text-dark me-3 align-self-center ${
                      submitClicked ? "" : "d-none"
                    }`}
                    role="status"
                    style={{
                      width: "32.6px",
                      height: "30px"
                    }}
                  >
                    <span className="sr-only"></span>
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary fs-3 px-5"
                    style={{
                      backgroundColor: ThemeButtonBGPrimary,
                      width: "100%",
                      height: "60px",
                    }}
                  >
                    Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginContent;
